// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateRangeSelector-module__container___ZeUGb {
    background-color: #222222;
    padding: 20px;
    display: flex;
    flex-direction: column;
    width: 320px;
    height: 159px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
}


.DateRangeSelector-module__row___RgLLu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.DateRangeSelector-module__labelContainer___pdrzf {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.DateRangeSelector-module__label___FX3Oq {
    color: white;
    font-size: 14px;
    margin-bottom: 5px;
}

.DateRangeSelector-module__input___TuyCg {
    padding: 5px;
    font-size: 14px;
    width: 130px;
}

.DateRangeSelector-module__button___hZtEB {
    background-color: var(--bmo-primary-color-mint);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    cursor: pointer;
    align-self: flex-start; 
}

    .DateRangeSelector-module__button___hZtEB:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.DateRangeSelector-module__postingSelector___EiyuP {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/DateRangeSelector/DateRangeSelector.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,sGAAsG;AAC1G;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;IAEI;QACI,oDAAoD;IACxD;;AAEJ;IACI,WAAW;AACf","sourcesContent":[".container {\n    background-color: #222222;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    width: 320px;\n    height: 159px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n}\n\n\n.row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.labelContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.label {\n    color: white;\n    font-size: 14px;\n    margin-bottom: 5px;\n}\n\n.input {\n    padding: 5px;\n    font-size: 14px;\n    width: 130px;\n}\n\n.button {\n    background-color: var(--bmo-primary-color-mint);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    padding: 10px 20px;\n    cursor: pointer;\n    align-self: flex-start; \n}\n\n    .button:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.postingSelector {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DateRangeSelector-module__container___ZeUGb`,
	"row": `DateRangeSelector-module__row___RgLLu`,
	"labelContainer": `DateRangeSelector-module__labelContainer___pdrzf`,
	"label": `DateRangeSelector-module__label___FX3Oq`,
	"input": `DateRangeSelector-module__input___TuyCg`,
	"button": `DateRangeSelector-module__button___hZtEB`,
	"postingSelector": `DateRangeSelector-module__postingSelector___EiyuP`
};
export default ___CSS_LOADER_EXPORT___;
